import React from "react";
import addDays from "date-fns/addDays";
import IconButton from "@mui/material/IconButton";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import {addMonths, format, startOfMonth} from "date-fns";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';

export default function CalendarSelectMonth({dateRange, compact = false, prevMonth = () => {}, nextMonth = () => {}, onMonthChange = () => {}}) {
  const currentMonth = startOfMonth(new Date());
  const selectedMonth = dateRange[0] ? startOfMonth(addDays(dateRange[0], 6)) : currentMonth;
  const selectedValue = format(selectedMonth, 'yyyy-MM');
  const months = Array.from({length: 13}, (_, index) => addMonths(currentMonth, index - 6));
  // Keep the selected month visible when arrows or a saved URL go beyond the dropdown window.
  if (!months.some(month => format(month, 'yyyy-MM') === selectedValue)) {
    months.push(selectedMonth);
    months.sort((a, b) => a - b);
  }
  return (
    <div style={{display: 'flex', alignItems: 'center', width: compact ? '100%' : 320, maxWidth: '100%', minWidth: 0}}>
      <FormControl size="small" sx={{minWidth: 0, flex: 1, mr: 1}}>
        <InputLabel id="calendar-select-month-label">Select Month</InputLabel>
        <Select labelId="calendar-select-month-label" id="calendar-select-month" label="Select Month"
          value={selectedValue} onChange={event => onMonthChange(months.find(month => format(month, 'yyyy-MM') === event.target.value))}>
          {months.map(month => <MenuItem key={format(month, 'yyyy-MM')} value={format(month, 'yyyy-MM')}>
            {format(month, 'MMMM yyyy')}
          </MenuItem>)}
        </Select>
      </FormControl>
      <IconButton
        color="primary"
        aria-label="Go to the previous month"
        onClick={(e) => prevMonth()}
        size="large">
        <NavigateBeforeIcon/>
      </IconButton>
      <IconButton
        color="primary"
        aria-label="Go to the next month"
        onClick={() => nextMonth()}
        size="large">
        <NavigateNextIcon/>
      </IconButton>
    </div>
  );
}
